import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/soul";
import { CalendarDays } from "lucide-react";

export default function WordArchive() {
  const [archive, setArchive] = useState([]);

  useEffect(() => {
    api.get("/words/archive?days=30").then((r) => setArchive(r.data.archive || []));
  }, []);

  const fmt = (iso) =>
    new Date(iso + "T00:00:00").toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });

  return (
    <main data-testid="word-archive-page" className="max-w-4xl mx-auto px-6 py-16">
      <div className="max-w-3xl mb-12 fade-up">
        <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-4 flex items-center gap-2">
          <CalendarDays size={14} /> Word of the Day · Archive
        </p>
        <h1 className="serif text-4xl sm:text-6xl font-light text-[#F5F1E7]">
          Words you may have <span className="italic-serif text-[#D4AF37]">missed</span>
        </h1>
        <p className="mt-5 text-[#A8A29E] leading-relaxed text-lg">
          The last thirty days of powerful words. Revisit any of them and trace their origins.
        </p>
      </div>

      <div className="space-y-3" data-testid="archive-list">
        {archive.map((w, i) => (
          <div
            key={w.date}
            data-testid={`archive-item-${i}`}
            className={`glass rounded-2xl p-6 ${i === 0 ? "gold-glow border-[#D4AF37]/40" : ""}`}
          >
            <div className="flex items-baseline justify-between gap-3">
              <h2 className="serif text-3xl text-[#F5F1E7]">
                {w.term}
                {i === 0 && <span className="ml-3 text-xs uppercase tracking-[0.2em] text-[#D4AF37]">Today</span>}
              </h2>
              <span className="text-sm text-[#A8A29E] whitespace-nowrap">{fmt(w.date)}</span>
            </div>
            <p className="mt-2 text-[#A8A29E] text-sm">{w.origin}</p>
            <p className="mt-2 text-[#F5F1E7] leading-relaxed italic-serif">{w.meaning}</p>
          </div>
        ))}
      </div>

      <Link to="/words" className="mt-10 inline-block text-[#D4AF37] hover:underline" data-testid="archive-to-explorer">
        Look up any word's origins →
      </Link>
    </main>
  );
}
